module.exports = __webpack_public_path__ + "img/dangActivity.5b20c467.png";